export default {"src":"/_next/static/media/call-icon.ba85d2da.svg","height":18,"width":18};